import type { ReactNode } from 'react';

export interface ProfileCardProps {
  title: ReactNode;
  /** Header action, normally the section's Edit button. */
  action?: ReactNode;
  /** `attention` = the dashed amber note card, pale amber fill (Preferred geographies, FR-175). */
  tone?: 'default' | 'attention';
  /** Stack the body as a column with 14px gaps (media rows). */
  stacked?: boolean;
  children: ReactNode;
}

const TONE = {
  default: 'bg-white shadow-card',
  attention: 'border border-dashed border-attention bg-yellow/10',
} as const;

/**
 * One profile section card (client-approved Option D, `.card` + `.hd` in the
 * mockup): white, 20px radius, 26px/28px padding, an 18px title row with the
 * Edit action on the right.
 */
export function ProfileCard({
  title,
  action,
  tone = 'default',
  stacked = false,
  children,
}: ProfileCardProps) {
  return (
    <section
      className={`rounded-card flex h-full flex-col px-7 py-[1.625rem] ${TONE[tone]} ${stacked ? 'gap-3.5' : ''}`}
    >
      <div
        className={`flex items-center justify-between gap-3 ${stacked ? 'mb-1' : 'mb-[1.125rem]'}`}
      >
        <h2 className="text-h5 text-navy flex items-center gap-2 font-sans">{title}</h2>
        {action}
      </div>
      {children}
    </section>
  );
}
